import { render } from "./homeTestimonials.vue?vue&type=template&id=2d9fbd40&scoped=true"
import script from "./homeTestimonials.vue?vue&type=script&lang=js"
export * from "./homeTestimonials.vue?vue&type=script&lang=js"

import "./homeTestimonials.vue?vue&type=style&index=0&id=2d9fbd40&scoped=true&lang=css"

import exportComponent from "C:\\blissappp\\theblissholidays\\bliss-site\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2d9fbd40"]])

export default __exports__